import React, { ReactNode, useRef, useEffect, useState } from 'react';
import './Cell.css';
import '../styles/styles.css';
import { Divider } from './Divider';
import { HStack, VStack } from './Stack';
import { Space } from './Space';

interface CellProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
  align?: 'middle' | 'top';
  dividerExtendRight?: boolean;
  dividerExtendLeft?: boolean;
  showDivider?: boolean;
  highlight?: boolean;
  media?: ReactNode;
}

const Cell: React.FC<CellProps> = ({
  onClick,
  children,
  align = 'middle',
  dividerExtendLeft = false,
  dividerExtendRight = false,
  showDivider = false,
  highlight = false,
  media,
}) => {
  const mediaRef = useRef<HTMLDivElement>(null); // Ref for the media container
  const [indentation, setIndentation] = useState(0);

  useEffect(() => {
    // Calculate the width of the media element when it exists
    setTimeout(() => {
      if (mediaRef.current) {
        const mediaWidth = mediaRef.current.offsetWidth;
        setIndentation(mediaWidth);
      }
    }, 100); // Delay calculation until after the render cycle
  }, [media]); // Recalculate whenever the media prop changes

  return (
    <>
      <div className="cell-wrapper v-stack width-fill">
        <button
          onClick={onClick}
          className={`cell-button h-stack width-fill height-hug group ${highlight ? 'highlight' : ''} ${align}`}
        >
          {media && (
            <>
              <div ref={mediaRef}>
                {media}
              </div>
              <Space.Content />
            </>
          )}
          <div className="v-stack width-fill cell-children">
            {children}
          </div>
        </button>
        {showDivider && (
          <HStack className="cell-divider"
            style={{
              paddingLeft: `${indentation}px`, // Align divider with children
              marginRight: `${dividerExtendRight && 'calc(var(--ts-space-h-section) * -1'}`, // Extend divider to section wrapper
            }}
          >
            {media && <Space.Content />}
            <Divider nested />
          </HStack>
        )}
      </div>
    </>
  );
};

export { Cell, CellProps };
